// Libs
import classNames from 'classnames/bind';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Stack } from '@mui/material';
import { useFieldArray, useFormContext } from 'react-hook-form';
// Components, Layouts, Pages
import { BaseLabel, BaseSelectFileModal, ItemFileAttachment, UnderDevelopment } from '~/components/common';
// Others
import { IFormOrder } from '~/utils/interface/order';
import { IBaseFile } from '~/utils/interface/common';
// Styles, images, icons
import styles from './AttachmentsOrderForm.module.scss';
import { icons } from '~/assets';

type Props = {
  onRemoveFile?: (id: string) => void;
};

const cx = classNames.bind(styles);

const AttachmentsOrderForm = (props: Props) => {
  //#region Destructuring Props
  const { onRemoveFile } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/quotes', 'common/base']);

  const { control, watch } = useFormContext<IFormOrder>();

  const { append: appendOrderFiles, remove: removeOrderFiles } = useFieldArray({
    control,
    name: 'orderFile',
  });

  const filesOrder = watch('orderFile');
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [showAddFileModal, setShowAddFileModal] = useState<boolean>(false);
  const [showUnderDevelopment, setShowUnderDevelopment] = useState<boolean>(false);
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const handleShowAddFileModal = () => {
    setShowAddFileModal(!showAddFileModal);
  };

  const handleAddFile = (files: IBaseFile[]) => {
    if (!files) return;

    files.map((item) => appendOrderFiles(item));
  };

  const handleShowUnderDevelopment = () => {
    setShowUnderDevelopment(!showUnderDevelopment);
  };

  const handleRemoveFile = (file: IBaseFile, index?: number) => {
    if (!file.id) return;
    onRemoveFile?.(file.id);

    removeOrderFiles(index);
  };
  //#endregion Handle Function

  return (
    <Box id='attachmentsOrderFormComponent' className={cx('container')}>
      <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
        <BaseLabel icon={icons.commonIconAttachments} styleType='title' label={t('form_quotes_title_attachments')} />

        <Button
          variant='outlined'
          className={cx('buttonAddFile')}
          startIcon={<img src={icons.commonIconPlusPrimary} alt={t('common_alt_img')} />}
          onClick={handleShowAddFileModal}
        >
          {t('form_quotes_button_add_file')}
        </Button>
      </Stack>

      <Stack direction={'column'} gap={4}>
        {filesOrder &&
          filesOrder.length > 0 &&
          filesOrder.map((item, index) => (
            <ItemFileAttachment key={index} file={item} index={index} onRemoveFile={handleRemoveFile} />
          ))}
      </Stack>

      {showAddFileModal && <BaseSelectFileModal onAdd={handleAddFile} onClose={handleShowAddFileModal} />}

      {showUnderDevelopment && <UnderDevelopment onClose={handleShowUnderDevelopment} />}
    </Box>
  );
};

export default AttachmentsOrderForm;
